module.exports = __webpack_public_path__ + "static/media/control_cupboard.6a621388.jpg";